import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export interface miniListColumnItem {
  id: string | number;
  field: string | number;
  align: string;
  width: string;
  title: string;
  type?: "seq" | "";
  summary?: boolean;
  totalSummary?: string | number | null;
}

export const miniListProps = buildProps({
  columns: {
    type: definePropType<miniListColumnItem[]>(Array),
    default: () => [],
  },
  /** 表格数据 */
  list: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  /** 斑马纹 */
  stripe: {
    type: Boolean,
    default: true,
  },
  /** 高亮 */
  hover: {
    type: Boolean,
    default: false,
  },
  /** 是否显示表尾的合计 */
  showSummary: {
    type: Boolean,
    default: false,
  },
  /** 后台接口 合计的相关数据 */
  summaryObject: {
    type: Object,
    default: () => {
      return {};
    },
  },
  height: {
    type: Number,
  },
});
export type MiniListProps = ExtractPropTypes<typeof miniListProps>;
